import { useDisclosure } from "@mantine/hooks";
import { Modal, useMantineTheme } from "@mantine/core";
import { BingoGame } from "bingo/types/bingo-game.model";

interface HelpModalProps {
  bingoGame: BingoGame;
}

function HelpModal({ bingoGame }: HelpModalProps) {
  const [opened, { open, close }] = useDisclosure(true);
  const theme = useMantineTheme();

  const bgColor =
    bingoGame.bingoTemplateSnapshot.privateScreenSettings.popinBgColor;
  const textColor = "white";

  return (
    <>
      <Modal
        opened={opened}
        onClose={close}
        centered
        padding={15}
        radius={0}
        styles={{
          modal: {
            backgroundColor: bgColor,
            color: textColor,
          },
          header: {
            backgroundColor: bgColor,
            color: textColor,
          },
          body: {
            backgroundColor: bgColor,
            color: textColor,
          },
          close: {
            color: textColor,
          },
        }}
      >
        <p
          className="whitespace-pre-line pb-2"
          style={{
            fontFamily: theme.fontFamily,
          }}
        >
          {bingoGame.bingoTemplateSnapshot.frontOfficeMessages.drawExplainations
            ?.split(/([.!?])\s+/) // split by sentence-ending punctuation
            .reduce((acc: string[], part, idx, arr) => {
              if (/[.!?]/.test(part) && idx < arr.length - 1) {
                // punctuation + next space = add sentence end
                acc.push(part, "\n\n");
              } else {
                acc.push(part);
              }
              return acc;
            }, [])
            .join("")}
        </p>
      </Modal>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        onClick={open}
        className="icon icon-tabler icons-tabler-outline icon-tabler-help-circle"
      >
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
        <path d="M12 16v.01" />
        <path d="M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483" />
      </svg>
    </>
  );
}

export default HelpModal;
